import { cn } from '../cn.js';

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: number;
  className?: string;
}

/** Derive up to two initials from a display name. */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p.charAt(0).toUpperCase()).join('') || '?';
}

/** A circular avatar showing a photo when available, else initials. */
export function Avatar({ name, src, size = 44, className }: AvatarProps): JSX.Element {
  return (
    <span
      className={cn('as-avatar', className)}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {src ? <img src={src} alt={name} className="as-avatar__img" /> : initials(name)}
    </span>
  );
}
